
import React, { useState } from 'react';
import Bomeng from "./assets/BomengHealth.png";
import Ellembelle from './assets/Ellembelle Boreholes.jpg'
import Medical from './assets/Medical Bungalow.jpg'
import Facility from './assets/Toilet.jpg'
import Axim from './assets/Lower Axim.jpg'

import {
  TbSquareArrowRightFilled,
  TbSquareArrowLeftFilled,
} from "react-icons/tb";

const images = [
  { id: 1, src: Bomeng, title: "Bomeng Health Center" },
  { id: 2, src: Ellembelle, title: "Construction of 10 boreholes in the Ellembelle District" },
  { id: 3, src: Medical, title: "Renovation of Medical Superintendent Bungalow at Half Assini " },
  { id: 4, src: Facility, title: "Building of Modern Toilet Facility at Nkroful Agricultural SHS" },
  { id: 5, src: Axim, title: "Renovation at Lower Axim Government Hospital" },
];

const App = () => {
  const [visibleImages, setVisibleImages] = useState([
    images[0],
    images[1],
    images[2],
    images[3],
  ]);
  const [currentIndex, setCurrentIndex] = useState(0);

  const showNextImages = () => {
    // Calculate the next set of images in a loop
    const nextIndex = (currentIndex + 1) % images.length;
    const nextImages = [
      images[nextIndex],
      images[(nextIndex + 1) % images.length],
      images[(nextIndex + 2) % images.length],
      images[(nextIndex + 3) % images.length],
    ];

    setVisibleImages(nextImages);
    setCurrentIndex(nextIndex);
  };

  const showPreviousImages = () => {
    // Calculate the previous set of images in a loop
    const previousIndex = (currentIndex - 1 + images.length) % images.length;
    const previousImages = [
      images[previousIndex],
      images[(previousIndex + 1) % images.length],
      images[(previousIndex + 2) % images.length],
      images[(previousIndex + 3) % images.length],
    ];

    setVisibleImages(previousImages);
    setCurrentIndex(previousIndex);
  };

  return (
    <div className="flex flex-col mt-[1rem]">
      <div className='flex flex-row justify-between items-center'>
        <h1 className='font-fjalla text-[29px] pl-4'>Health and Sanitation Projects</h1>
        <div className='flex pr-5'>
          <TbSquareArrowLeftFilled
            onClick={showNextImages}
            className='h-7 w-7 cursor-pointer'
          />
          <TbSquareArrowRightFilled onClick={showPreviousImages} className='h-7 w-7 cursor-pointer' />
        </div>
      </div>
      <div className="flex flex-row w-full space-x-5 px-5">
        {visibleImages.map((image) => (
          <div key={image.id} className="flex flex-col w-1/4">
            <div className="relative">
              <img src={image.src} alt={`Image ${image.id}`} />
              <h1 className='font-fjalla text-[25px] absolute inset-0 text-center text-white bg-black bg-opacity-50 flex justify-center items-center'>
                {image.title}
              </h1>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default App;
